import { createFileRoute } from '@tanstack/react-router'

import { DealershipSettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/dealership')({
  component: DealershipSettingsPage,
})
